<template>
  <article 
    v-on:click="handleClick($event)"
    :class="{
      'card-folded':      true,
      'card--open':       isOpen,
      'card--closed':     isClosed,
      'card--horizontal': orientation == 'horizontal',
      'card--vertical':   orientation != 'horizontal',
    }">
    <section class="card-panel-cover">
      <section class="card-side-front">
        <slot name="cover-front"></slot>
      </section>
      <section class="card-side-back">
        <slot name="cover-back"></slot>
      </section>
    </section>
    <section class="card-panel-back">
      <section class="card-side-front">
        <slot name="backing-front"></slot>
      </section>
      <section class="card-side-back">
        <slot name="backing-back"></slot>
      </section>
    </section>
  </article>  
</template>

<script>
export default {
  props: [
    'isOpen',
    'isClosed',
    'orientation',
    'click'
  ],
  methods: {
    handleClick(event) {
      if (this.click) this.click(event);
    }
  }
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// folded-card.vue?685080e6